import LayoutBasic from "../layouts/layoutBasic";
import Link from "next/link";
import { withRouter } from "next/router";
import { GET } from "../helpers";
import {
  ASSET_PROFILE_URL,
  TOKEN,
  GET_USER_URL,
  CART,
  GET_CONTEST_DETAILS,
  GET_CONTESTS,
  CONTEST_PHOTOS_URL,
} from "../vars";
import { setLocalKeyValue, getLocalKeyValue } from "../storage";
import ListPhoto from "../components/listPhoto";
import PhotoListHolder from "../components/photoListHolder";
import moment from "moment";
import Img from "react-image";

class Contests extends React.Component {
  static async getInitialProps(props) {
    let token = (await process.browser)
      ? getLocalKeyValue(TOKEN)
      : props.query.sec_token;

    let contest_name = props.query.contest_name;
    let infoRequest = {},
      infoResponse = {},
      contestRequest = {},
      contestResponse = {},
      allContestRequest = {},
      allContestResponse = {};

    if (contest_name) {
      try {
        contestRequest = await GET(
          GET_CONTEST_DETAILS + "?contest_name=" + contest_name
        );
        contestResponse = await contestRequest.data;
      } catch (e) { }

    } else {
      try {
        allContestRequest = await GET(GET_CONTESTS);

        allContestResponse = await allContestRequest.data;
      } catch (e) {
        console.log("error", e);
      }
    }
    if (token) {
      try {
        infoRequest = await GET(GET_USER_URL, token);
        infoResponse = await infoRequest.data;
      } catch (e) { }

    }
    return {
      token: token,
      user: infoResponse.user,
      cart: infoResponse.cart,
      likes: infoResponse.likes,
      contest: contestResponse,
      contest_name: contest_name,
      allContestResponse: allContestResponse,
    };
  }

  render() {
    let contest_name = this.props.contest_name;
    let title = "Picxy Contest | " + contest_name;
    let content;
    let loader = <div className="image-holder"></div>;
    if (contest_name) {
      let contest_data = this.props.contest;
      if (contest_data.success) {
        let contest_details = contest_data.data;
        let contest_name = contest_details.title;

        let winners_details,
          special_mentions,
          winners = "";

        // contest with winners announcement
        // contest details page
        let link;
        if (new Date(contest_details.end_date) < new Date()) {
          link = (
            <div>
              <Link
                as={"/contests/entries/" + contest_details?.name}
                href={"contests/entries/?contest_name=" + contest_details?.name}
              >
                <a className="btn btn-primary">Check Entries</a>
              </Link>
            </div>
          );
        } else {
          link = (
            <div>
              <a
                target="_blank"
                className="btn btn-primary mr-3"
                href={"https://upload.picxy.com/signup"}
              >
                Upload Now
              </a>

              <Link
                as={"/contests/entries/" + contest_details?.name}
                href={"contests/entries/?contest_name=" + contest_details?.name}
              >
                <a className="btn btn-primary">Check Entries</a>
              </Link>
            </div>
          );
        }
        let banner_url = "/static/img/Picxy_Contest_Banner.jpg";
        if (contest_details.banner_image) {
          banner_url = CONTEST_PHOTOS_URL + contest_details.banner_image;
        }
        let sub_guidelines = contest_details.submission_guidelines;
        let start_date = contest_details.start_date;
        let end_date = contest_details.end_date;
        let date_formate =
          moment(start_date).format("D MMM") +
          " - " +
          moment(end_date).format("D MMM YY");
        if (moment(start_date).format("YY") !== moment(end_date).format("YY")) {
          date_formate =
            moment(start_date).format("D MMM YY") +
            " - " +
            moment(end_date).format("D MMM YY");
        }
        if (new Date(contest_details.end_date) < new Date()) {
          let results_date = moment(end_date)
            .add(15, "days")
            .format("D MMM YY");
          date_formate = <div>Results will be announced on {results_date}</div>;
          if (new Date(results_date) < new Date()) {
            date_formate = <div> Results will be announced tomorrow</div>;
          }
        }
        if (contest_details.name === "march2020") {
          date_formate = "";
          link = "";
        }
        let sub_text;
        if (sub_guidelines !== "") {
          sub_text = <h3>Submission Guidelines:</h3>;
        }

        content = (
          <div>
            <h1 className="text-center mb-2">
              <small className="text-capitalize">{contest_name}</small>
            </h1>
            <Img loader={loader} className="img-fluid" src={banner_url} />
            <h3 className="text-center mt-2">{date_formate}</h3>
            <div className="container font-small">
              <div className="text-center mb-5">
                <p className="mb-4 mt-4">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: contest_details.description,
                    }}
                  ></div>
                </p>
                {link}
              </div>

              {sub_text}
              <div dangerouslySetInnerHTML={{ __html: sub_guidelines }}></div>
            </div>
          </div>
        );
      } else {
        content = (
          <div className="container font-small mt-5">
            <div className="text-center mb-5">
              <h1>No Contest found</h1>
            </div>
          </div>
        );
      }
      return (
        <LayoutBasic title="Picxy Contests"  {...this.props}>
          {content}
        </LayoutBasic>
      );
    } else {
      let all_contest = this.props.allContestResponse;

      let active_contest_data = all_contest.active_contest;
      let active_contest = "";
      if (active_contest_data) {
        active_contest = active_contest_data.map((contest, id) => {
          let image = contest.image
            ? CONTEST_PHOTOS_URL + contest.image
            : "/static/img/Picxy_Contest_Photo.jpg";
          let start_date = contest.start_date;
          let end_date = contest.end_date;
          let date_formate =
            moment(start_date).format("D MMM") +
            " - " +
            moment(end_date).format("D MMM YY");
          if (
            moment(start_date).format("YY") !== moment(end_date).format("YY")
          ) {
            date_formate =
              moment(start_date).format("D MMM YY") +
              " - " +
              moment(end_date).format("D MMM YY");
          }
          return (
            <div className="col-md-4 mb-3">
              <Img
                loader={loader}
                className="img-fluid rounded-lg"
                src={image}
                alt={contest.title + "photo"}
              />
              <div className="text-center mt-1">
                <h4 className="text-capitalize">
                  <small>{contest.title}</small>
                </h4>
                <h6>{date_formate}</h6>
                <Link
                  as={"/contests/" + contest.name}
                  href={"contests/?contest_name=" + contest.name}
                >
                  <a
                    href={"contests/?contest_name=" + contest.name}
                    className="btn btn-primary"
                  >
                    Enter Now
                  </a>
                </Link>
                <Link
                  href={"contests/entires/?contest_name=" + contest.name}
                  as={"/contests/entires/" + contest.name}
                >
                  <a
                    href={"contests/entires/?contest_name=" + contest.name}
                    className="btn btn-primary"
                  >
                    Check Entries
                  </a>
                </Link>
              </div>
            </div>
          );
        });
      }

      let closed_contest_data = all_contest.closed_contests;
      let closed_contest = "";
      if (closed_contest_data) {
        closed_contest = closed_contest_data.map((contest, id) => {
          let closed_link = (
            <Link
              as={"/contests/" + contest.name}
              href={"contests/?contest_name=" + contest.name}
            >
              <a className="btn btn-primary">Enter Now</a>
            </Link>
          );
          if (contest.winners) {
            closed_link = (
              <Link
                as={"/contests/winners/" + contest.name}
                href={"contests/winners/?contest_name=" + contest.name}
              >
                <a className="btn btn-primary">Check Winners</a>
              </Link>
            );
          } else if (contest?.name == "bestshots19") {
            closed_link = (
              <Link
                as={"/contests/entries/" + contest.name}
                href={"contests/entries/?contest_name=" + contest.name}
              >
                <a className="btn btn-primary">Check Entries</a>
              </Link>
            );
          }
          let image = contest.image
            ? CONTEST_PHOTOS_URL + contest.image
            : "/static/img/Picxy_Contest_Photo.jpg";
          {
            if (contest.name === "march2020") {
              return <></>;
            } else {
              return (
                <div className="col-md-4 mb-3">
                  <Img
                    loader={loader}
                    className="img-fluid rounded-lg"
                    src={image}
                    alt={contest.title + "photo"}
                  />
                  <div className="text-center mt-2">
                    <h4 className="text-capitalize">
                      <small>{contest.title}</small>
                    </h4>
                    {closed_link}
                  </div>
                </div>
              );
            }
          }
        });
      }

      return (
        <LayoutBasic title="Picxy Contests" {...this.props}>
          <div className="container font-small mb-5">
            <div className="text-center">
              <h1>
                <small>Picxy Photo Contests</small>
              </h1>
            </div>
            <div className="row my-3 justify-content-center">
              {active_contest}
            </div>
            <h2 className="text-center my-3">Closed Contests</h2>
            <div className="row justify-content-center">{closed_contest}</div>
          </div>
        </LayoutBasic>
      );
    }
  }
}

export default withRouter(Contests);
